module.exports = __webpack_public_path__ + "static/media/advertise.46e52c2f.svg";